import React from 'react'
import Button, { TYPES as BUTTON_TYPES } from '../../../../../Button/index'
import { parseRefinementTags } from '../../../../../../services/community/oracle/discover-utils'

export interface DiscoverStreamingTextProps {
  text: string
  onRefineClick: (text: string) => void
  isStreaming: boolean
}

/**
 * Renders streamed Oracle text with inline refinement chips.
 *
 * Plain text segments are rendered as `<span>`, and `<Gaia type="refine" />`
 * tags become clickable pill buttons. When `isStreaming` is true, a blinking
 * cursor is appended to indicate the response is still arriving.
 */
function DiscoverStreamingText ({
  text,
  onRefineClick,
  isStreaming,
}: DiscoverStreamingTextProps) {
  const segments = parseRefinementTags(text)

  if (segments.length === 0 && !isStreaming) return null

  return (
    <div
      className="playlist-tab-container__discover-streaming"
      role="status"
      aria-live="polite"
      aria-atomic="false"
    >
      <p className="playlist-tab-container__discover-streaming-text">
        {segments.map((segment, index) => {
          const key = `seg-${index}`
          if (segment.type === 'refine') {
            return (
              <Button
                key={key}
                type={BUTTON_TYPES.GHOST}
                className="playlist-tab-container__refine-chip playlist-tab-container__refine-chip--inline"
                onClick={() => {
                  onRefineClick(segment.value)
                }}
              >
                {segment.value}
              </Button>
            )
          }
          return <span key={key}>{segment.value}</span>
        })}
        {isStreaming && (
          <span className="playlist-tab-container__streaming-cursor" aria-hidden="true" />
        )}
      </p>
    </div>
  )
}

export default React.memo(DiscoverStreamingText)
